import React, { useContext, useState } from "react";
import {
  Divider,
  Grid,
  Card,
  Header,
  Button,
  Label,
  List,
  ListItem,
} from "semantic-ui-react";
import UserContext from "contexts/UserContext";
import { API } from "aws-amplify";
import { Elements, useStripe } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe("pk_live_WtzlnnqLUnIyeQhro7KiFaLK004yZdRJ21");

const createCheckoutSession = async (user, plan) => {
  const apiName = "KnowMyDayAPI";
  const path = "/create-checkout-session";

  const attrs = {
    body: {
      customer: user.getAttributes().stripeCustomerId,
      user: user.getAttributes().sub,
      plan
    },
  };

  console.log("attrs", attrs);
  const result = await API.post(apiName, path, attrs);
  return result;
};
const SubscribeButton = ({plan}) => {
  const stripe = useStripe();
  const [isLoading, setIsLoading] = useState(false);
  const user = useContext(UserContext);
  console.log(user);

  const handleClick = async () => {
    setIsLoading(true);
    const session = await createCheckoutSession(user, plan);
    const result = stripe.redirectToCheckout({ sessionId: session.id });

    if (result.error) {
      // If `redirectToCheckout` fails due to a browser or network
      // error, display the localized error message to your customer.
      var displayError = document.getElementById("error-message");
      displayError.textContent = result.error.message;
    }
  };

  return (
    <Button
      onClick={handleClick}
      loading={isLoading}
      disabled={user.isPro()}
      color="teal"
    >
      Try it free for 30 days
      <br />
      <small>{plan === "annual" ? "Then 49.99/year (Save 16%)" : "Then $4.99/month"}</small>
    </Button>
  );
};

const PricingPage = () => {
  return (
    <Grid columns="equal">
      <Grid.Row>
        <Grid.Column>
          <Header as="h1" textAlign="center">
            Unlock the full power of Know My Day!
          </Header>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <Card.Group centered itemsPerRow={3} stackable>
            <Card fluid raised color="teal">
              <Card.Content textAlign="center" header="Basic" />
              <Card.Content>
                <List bulleted>
                  <ListItem>Unlimited Students</ListItem>
                  <ListItem>Unlimited Support Staff</ListItem>
                  <ListItem>Basic Reports</ListItem>
                  <ListItem>Notifications to Parents</ListItem>
                </List>
              </Card.Content>
              <Card.Content textAlign="center">
                <Header>Free</Header>
              </Card.Content>
            </Card>
            <Card fluid raised color="teal">
              <Card.Content textAlign="center">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Header style={{ margin: 0 }} floated="left">
                    Know My Day Pro for Individuals
                  </Header>
                </div>
              </Card.Content>
              <Card.Content>
                <List bulleted>
                  <ListItem>Unlimited students</ListItem>
                  <ListItem>Unlimited Support Staff</ListItem>
                  <ListItem>Advanced reports with images, links, etc.</ListItem>
                  <ListItem>Report comments</ListItem>
                  <ListItem>
                    Report and comment translation
                    <Label
                      style={{ marginLeft: "0.5em" }}
                      size="mini"
                      color="blue"
                      horizontal
                    >
                      New
                    </Label>
                  </ListItem>
                  <ListItem>
                    Print range of reports
                    <Label
                      style={{ marginLeft: "0.5em" }}
                      size="mini"
                      color="blue"
                      horizontal
                    >
                      New
                    </Label>
                  </ListItem>
                  <ListItem>Notifications to Parents</ListItem>
                </List>
              </Card.Content>
              <Card.Content textAlign="center">
                <Elements stripe={stripePromise}>
                  <SubscribeButton plan="monthly"/>
                  <Divider horizontal>Or</Divider>
                  <SubscribeButton plan="annual"/>
                </Elements>
              </Card.Content>
            </Card>
            <Card fluid raised color="teal">
              <Card.Content
                textAlign="center"
                header="Know My Day Pro for Organizations"
              />
              <Card.Content>
                <List bulleted>
                  <ListItem>
                    Unlock all the features of Know My Day Pro for your entire
                    school or organization
                  </ListItem>
                  <ListItem>Dedicated Support</ListItem>
                  <ListItem>User Training</ListItem>
                </List>
              </Card.Content>
              <Card.Content textAlign="center">
                <Button color="teal">Contact Sales</Button>
              </Card.Content>
            </Card>
          </Card.Group>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default PricingPage;
